// extracted by mini-css-extract-plugin
module.exports = {"ctn":"terms_ctn__3iWYH","link":"terms_link__7WyTR"};